import { render, staticRenderFns } from "./API.vue?vue&type=template&id=8d8e2b60&scoped=true"
import script from "./API.vue?vue&type=script&lang=js"
export * from "./API.vue?vue&type=script&lang=js"
import style0 from "./API.vue?vue&type=style&index=0&id=8d8e2b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8e2b60",
  null
  
)

export default component.exports